module.exports = __webpack_public_path__ + "b1b812aa6bb020807e6df027f11350d4.ttf";